import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=fce5934a&scoped=true&"
import script from "./Business.vue?vue&type=script&lang=ts&"
export * from "./Business.vue?vue&type=script&lang=ts&"
import style0 from "./Business.vue?vue&type=style&index=0&id=fce5934a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce5934a",
  null
  
)

export default component.exports